import type { MisconceptionDefinition } from '../types';
export const coordinatenMisconceptions: MisconceptionDefinition[] = [{
  id: 'met.coord-xy-omgedraaid',
  label: 'x en y omgedraaid',
  module: 'Metriek',
  description: 'Leerling leest of schrijft eerst y en daarna x bij een coördinaat.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-y-als-x-gelezen',
  label: 'y-coördinaat als x gelezen',
  module: 'Metriek',
  description: 'Leerling gebruikt het tweede getal alsof het de x-coördinaat is.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-x-als-y-gelezen',
  label: 'x-coördinaat als y gelezen',
  module: 'Metriek',
  description: 'Leerling gebruikt het eerste getal alsof het de y-coördinaat is.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-translatie-x-vergeten',
  label: 'x-verandering vergeten bij verschuiving',
  module: 'Metriek',
  description: 'Leerling verandert alleen de y-coördinaat bij een verschuiving en laat x gelijk.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-translatie-y-vergeten',
  label: 'y-verandering vergeten bij verschuiving',
  module: 'Metriek',
  description: 'Leerling verandert alleen de x-coördinaat bij een verschuiving en laat y gelijk.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-translatie-aftrekken',
  label: 'Aftrekken bij verschuiving naar rechts/omhoog',
  module: 'Metriek',
  description: 'Leerling trekt de verschuiving af in plaats van op te tellen bij naar rechts of omhoog.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-oorsprong-een-een',
  label: 'Oorsprong als (1,1)',
  module: 'Metriek',
  description: 'Leerling denkt dat het assenstelsel begint bij (1, 1).',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-oorsprong-op-as',
  label: 'Oorsprong op één as',
  module: 'Metriek',
  description: 'Leerling kiest een punt op de x- of y-as (zoals (1,0) of (0,1)) als oorsprong.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-rechthoek-x-fout',
  label: 'Verkeerde x bij vierde hoekpunt',
  module: 'Metriek',
  description: 'Leerling kiest een x-coördinaat die bij geen van de gegeven hoekpunten hoort.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-rechthoek-y-fout',
  label: 'Verkeerde y bij vierde hoekpunt',
  module: 'Metriek',
  description: 'Leerling kiest een y-coördinaat die bij geen van de gegeven hoekpunten hoort.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-afstand-optellen',
  label: 'Coördinaten optellen i.p.v. aftrekken',
  module: 'Metriek',
  description: 'Leerling telt y-coördinaten op voor de afstand i.p.v. ze van elkaar af te trekken.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-afstand-rekenfout',
  label: 'Rekenfout bij afstand',
  module: 'Metriek',
  description: 'Leerling maakt een rekenfout bij het verschil tussen twee coördinaten.',
  typicalFamilies: ['MET-COORDINATEN']
}, {
  id: 'met.coord-afstand-coordinaat-ipv-verschil',
  label: 'Coördinaat i.p.v. afstand gegeven',
  module: 'Metriek',
  description: 'Leerling geeft een van de coördinaten als afstand in plaats van het verschil.',
  typicalFamilies: ['MET-COORDINATEN']
}];